import { T } from "@repo/transifex";
import { LogoBarcodeError } from "~/components/kiosk/svgs/barcode-error";

import { Modal, type ModalProps } from "../shared/modal";
import { ModalButton } from "../shared/modal-button";
import { ModalButtonGroup } from "../shared/modal-button-group";
import { ModalTitle } from "../shared/modal-title";

type ModalErrorBarcodeProps = Pick<ModalProps, "open"> & {
  onClose: () => void;
};

export const ModalErrorBarcode = ({
  onClose,
  open = true
}: ModalErrorBarcodeProps) => {
  return (
    <Modal backdropVariant="error" open={open}>
      <div className="flex flex-col gap-16 px-32 text-center">
        <div className="flex justify-center">
          <LogoBarcodeError />
        </div>

        <ModalTitle size="9xl" variant="error" weight="black">
          <T _str="Barcode not recognised" />
        </ModalTitle>

        <p className="text-6xl text-kiosk-text-white">
          <T _str="Please try again or contact staff" />
        </p>

        <ModalButtonGroup className="mt-16">
          <ModalButton variant="idle" onClick={onClose}>
            <T _str="Close" />
          </ModalButton>
        </ModalButtonGroup>
      </div>
    </Modal>
  );
};
